import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Radio, Form } from 'antd';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import './RegPrivacyPolicy.css';

@inject('translationsStore', 'moveinStore')
@observer
export default class RegPrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visiblePrivacyPolicyModal: false,
      visiblePrivacyPolicyThirdPartiesModal: false,
    };
  }

  showPrivacyPolicy = () => {
    this.setState({ visiblePrivacyPolicyModal: true });
  };

  showPrivacyPolicyThirdParties = () => {
    this.setState({ visiblePrivacyPolicyThirdPartiesModal: true });
  };

  render() {
    const { translationsStore, form, initialValue, disabled, initialThirdParties, marketingThirdParties } = this.props;
    return (
      <div className="RegPrivacyPolicy">
        <div className="privacyBox">
          <p className="RegPrivacyIntro">
            {translationsStore.translate('movein.consents.informativaIntro1')}
            <a href="#" className="informativa" onClick={this.showPrivacyPolicy}>
              {translationsStore.translate('movein.consents.informativaLink')}
            </a>
            {translationsStore.translate('movein.consents.informativaIntro2')}
          </p>
          <div className="RegPrivacyConsent">
            {translationsStore.translate('movein.consents.marketing1')}
            <a href="#" className="informativa" onClick={this.showPrivacyPolicy}>
              {translationsStore.translate('movein.consents.informativaLink')}
            </a>
            {translationsStore.translate('movein.consents.marketing2a')}
            <a href="https://www.myair.io/" target="_blank" rel="noopener noreferrer">
              www.myair.io
            </a>
            {translationsStore.translate('movein.consents.marketing2b')}{' '}
            <a href="https://www.myair.io/" target="_blank" rel="noopener noreferrer">
              www.myair.io
            </a>
            :
          </div>
          <Form.Item>
            {form.getFieldDecorator('marketingAgreement', {
              preserve: true,
              initialValue
            })(
              <Radio.Group disabled={disabled}>
                <Radio value={true}>{translationsStore.translate('movein.consents.agree')}</Radio>
                <Radio value={false}>{translationsStore.translate('movein.consents.disagree')}</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          {this.props.submitted && (this.props.marketingValue === null || this.props.marketingValue === undefined) && (
            <div className="RegPrivacyError">{translationsStore.translate('registration.form.errorInvalidMarketingPolicy')}</div>
          )}
          <div className="RegPrivacyConsent">
            {translationsStore.translate('movein.consents.thirdParties1')}
            <a href="#" className="informativa" onClick={this.showPrivacyPolicyThirdParties}>
              {translationsStore.translate('movein.consents.informativaLink')}
            </a>
            {translationsStore.translate('movein.consents.thirdParties2')}
          </div>
          <Form.Item>
            {form.getFieldDecorator('marketingThirdPartiesAgreement', {
              preserve: true,
              initialValue: initialThirdParties
            })(
              <Radio.Group>
                <Radio value={true}>{translationsStore.translate('movein.consents.agree')}</Radio>
                <Radio value={false}>{translationsStore.translate('movein.consents.disagree')}</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          {this.props.submitted && marketingThirdParties === undefined && (
            <div className="RegPrivacyError">{translationsStore.translate('registration.form.errorInvalidMarketingPolicy')}</div>
          )}
        </div>
        <PrivacyPolicyModal
          visible={this.state.visiblePrivacyPolicyModal}
          onCancel={() => {
            this.setState({ visiblePrivacyPolicyModal: false });
          }}
        />
        <PrivacyPolicyModal
          assetName="movein-personal-data-processing-policy-third-parties.pdf"
          visible={this.state.visiblePrivacyPolicyThirdPartiesModal}
          onCancel={() => {
            this.setState({ visiblePrivacyPolicyThirdPartiesModal: false });
          }}
        />
      </div>
    );
  }
}
